import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AppReviewAssignmentRepository = {
  getAllReviewsForAssignment: (page, size, searchParams) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviewAssignments`,
      method: "POST",
      params: {
        page: page,
        size: size,
      },
      data: searchParams,
    });
  },

  getPotentialAssignees: (reviewId) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviewAssignments/potentialAssignees/${reviewId}`,
      method: "GET",
    });
  },

  assignReviewToUser: (reviewId, assigneeId) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviewAssignments/assign/${reviewId}`,
      method: "POST",
      params: {
        userId: assigneeId,
      },
    });
  },
};
